import React from 'react';
import PropTypes from 'prop-types';

export const FormBackButton = ({
  children,
  disabled = false,
  type = 'button',
  ...props
}) => {
  return (
    <button
      className="swformback__btn"
      type={type}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

FormBackButton.propTypes = {
  children: PropTypes.any.isRequired,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  onClick: PropTypes.func
};
